import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Form from 'flarum/common/components/Form';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import withAttr from 'flarum/common/utils/withAttr';
import haptic from 'flarum/common/utils/haptic';
export default class SouqFlagPostModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.success = false;
    this.reason = Stream('');
    this.reasonDetail = Stream('');
  }
  className() {
    return 'SouqFlagPostModal Modal--medium';
  }
  title() {
    return 'Report Souq Listing';
  }
  reasons() {
    return [{
      key: 'scam',
      label: 'Suspected Scam or Fraud',
      description: 'Fake seller, payment scam, suspicious transaction, or fraudulent activity.'
    }, {
      key: 'misleading',
      label: 'Misleading Listing',
      description: 'Wrong description, fake photos, hidden defects, or misleading information.'
    }, {
      key: 'price',
      label: 'Incorrect or Bait Price',
      description: 'The advertised price appears intentionally false or misleading.'
    }, {
      key: 'prohibited',
      label: 'Prohibited / Restricted Listing',
      description: 'Illegal, restricted, unsafe, counterfeit, stolen, visa or sponsorship-related, or otherwise prohibited.'
    }, {
      key: 'spam',
      label: 'Spam or Duplicate Listing',
      description: 'Repeated, promotional, irrelevant, or duplicate advertisement.'
    }, {
      key: 'unavailable',
      label: 'Item Already Sold / Unavailable',
      description: 'The item appears sold or unavailable but is still being advertised.'
    }, {
      key: 'suspicious_contact',
      label: 'Suspicious Contact or Payment Request',
      description: 'Suspicious advance payment, bank transfer, external link, or contact request.'
    }, {
      key: 'other',
      label: 'Other',
      description: 'Report another problem with this listing.'
    }];
  }
  content() {
    if (this.success) {
      return m("div", {
        className: "Modal-body"
      }, m(Form, {
        className: "Form--centered"
      }, m("div", {
        className: "SouqReportSuccess"
      }, m("div", {
        className: "SouqReportSuccess-icon"
      }, "\u2713"), m("h3", null, "Report submitted"), m("p", null, "Thank you. Your report has been sent to the PinoyTalks moderation team.")), m("div", {
        className: "Form-group Form-controls"
      }, m(Button, {
        className: "Button Button--primary Button--block",
        onclick: this.hide.bind(this)
      }, "Close"))));
    }
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "SouqReportIntro"
    }, "Choose the reason that best describes the problem with this listing."), m("div", {
      className: "SouqReportReasons"
    }, this.reasons().map(reason => m("label", {
      className: 'SouqReportReason ' + (this.reason() === reason.key ? 'is-selected' : '')
    }, m("div", {
      className: "SouqReportReason-main"
    }, m("input", {
      type: "radio",
      name: "souq-report-reason",
      value: reason.key,
      checked: this.reason() === reason.key,
      onclick: withAttr('value', this.reason)
    }), m("div", {
      className: "SouqReportReason-copy"
    }, m("strong", null, reason.label), m("span", null, reason.description))), this.reason() === reason.key && m("textarea", {
      className: "FormControl SouqReportDetails",
      rows: "3",
      placeholder: reason.key === 'other' ? 'Please explain the problem...' : 'Additional details for our moderators (optional)...',
      value: this.reasonDetail(),
      oninput: withAttr('value', this.reasonDetail)
    })))), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading,
      disabled: !this.reason() || this.reason() === 'other' && !this.reasonDetail().trim()
    }, "Submit Report"))));
  }
  onsubmit(e) {
    e.preventDefault();
    if (!this.reason()) {
      return;
    }
    const selected = this.reasons().find(reason => reason.key === this.reason());
    if (!selected) {
      return;
    }
    if (this.reason() === 'other' && !this.reasonDetail().trim()) {
      return;
    }
    haptic('warning');
    this.loading = true;
    const detail = this.reasonDetail().trim();
    let reasonDetail = '[Souq Report: ' + selected.label + ']';
    if (detail) {
      reasonDetail += '\n\n' + detail;
    }
    app.store.createRecord('flags').save({
      /*
       * Store it as Flarum's "Other"
       * type while preserving our exact
       * Souq reason in reasonDetail.
       */
      reason: null,
      reasonDetail: reasonDetail,
      relationships: {
        post: this.attrs.post
      }
    }, {
      errorHandler: this.onerror.bind(this)
    }).then(() => {
      this.success = true;
    }).catch(() => {}).then(this.loaded.bind(this));
  }
}
flarum.reg.add('pinoytalks-souq', 'forum/components/SouqFlagPostModal', SouqFlagPostModal);